import * as React from "react";
const SvgLeftArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 18, viewBox: "0 0 10 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 16.5L1.5 9L9 1.5", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgLeftArrow;
